<template>
    <nav class="navbar">
        <NuxtLink to="/" class="company-logo-full">
            <img class="company-logo" src="assets/images/logo-company.png" alt="">
            <img class="company-logo-letters" src="assets/images/logo-company-lettes.png" alt="">
        </NuxtLink>

        <DropDown class="navbar--small" dropDownHead="/icons/burger.png" :dropDownEntries='[
                { url: "/", title: "Accueil" },
                { url: "/landing-page", title: "Landing page" },
                { url: "/websites", title: "Websites" },
                { url: "/expertise", title: "Expertise" },
                { url: "/contact", title: "Contact" },
            ]
            ' />

        <ul class="navbar--large navbar-items">
            <li class="navbar-item">
                <NuxtLink activeClass="active-route" to="/">Accueil</NuxtLink>
            </li>
            <li class="navbar-item">
                <NuxtLink activeClass="active-route" to="/landing-page">Landing page</NuxtLink>
            </li>
            <li class="navbar-item">
                <NuxtLink activeClass="active-route" to="/websites">Websites</NuxtLink>
            </li>
            <li class="navbar-item">
                <NuxtLink activeClass="active-route" to="/expertise">Expertise</NuxtLink>
            </li>
            <li class="navbar-item">
                <NuxtLink activeClass="active-route" to="/contact">Contact</NuxtLink>
            </li>
        </ul>

        <svg class="navigation-decoration" width="600" height="72" viewBox="0 0 600 72"
            xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
            <path
                d="M102 0L0 25V72H600V35L570 21L544.908 30L428.5 0L350.083 30L345.576 26L338.564 35L279 6L185.81 26L173.5 14L102 0Z" />
        </svg>
    </nav>
</template>

<script setup>
</script>

<style scoped lang="scss">
@use "./index.scss";
</style>
